/* ============================================
   HardGuard Neon Luxe — theme.js
   ============================================ */

(function () {
  'use strict';

  // ===== CART STATE =====
  window.HGCart = {
    items: [],
    total: 0,
    count: 0,
  };

  // ===== UTILITY =====
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);
  const off = (el, ev, fn) => el && el.removeEventListener(ev, fn);
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function debounce(fn, ms = 300) {
    let t;
    return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
  }

  // ===== HEADER SCROLL =====
  function initHeaderScroll() {
    const header = $('.site-header');
    if (!header) return;
    const handler = debounce(() => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, 10);
    on(window, 'scroll', handler, { passive: true });
  }

  // ===== MOBILE NAV =====
  function initMobileNav() {
    const toggle = $('.mobile-menu-toggle');
    const nav = $('.mobile-nav');
    const close = $('.mobile-nav__close');
    if (!toggle || !nav) return;
    on(toggle, 'click', () => {
      nav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
    const closeNav = () => {
      nav.classList.remove('open');
      document.body.style.overflow = '';
    };
    on(close, 'click', closeNav);
    on(nav, 'click', (e) => { if (e.target === nav) closeNav(); });
  }

  // ===== ANNOUNCEMENT BAR =====
  function initAnnouncementBar() {
    const track = $('.announcement-bar__track');
    if (!track) return;
    // Clone for seamless loop
    const clone = track.cloneNode(true);
    track.parentElement.appendChild(clone);
  }

  // ===== COUNTDOWN TIMER =====
  function initCountdown() {
    var el = document.getElementById('countdown-timer');
    if (!el) return;
    var raw = el.getAttribute('data-end') || '2025-12-31T23:59:59';
    // Normalize: replace space separator with T for iOS Safari compatibility
    raw = raw.trim().replace(' ', 'T');
    var endDate = new Date(raw);
    // Fallback if parse fails
    if (isNaN(endDate.getTime())) {
      endDate = new Date('2025-12-31T23:59:59');
    }
    var days  = document.getElementById('cd-days');
    var hours = document.getElementById('cd-hours');
    var mins  = document.getElementById('cd-mins');
    var secs  = document.getElementById('cd-secs');
    function pad(n) { return String(n).padStart(2, '0'); }
    function update() {
      var diff = endDate.getTime() - Date.now();
      if (diff <= 0) {
        var section = el.closest('.countdown-section');
        if (section) section.style.display = 'none';
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (days)  days.textContent  = pad(d);
      if (hours) hours.textContent = pad(h);
      if (mins)  mins.textContent  = pad(m);
      if (secs)  secs.textContent  = pad(s);
    }
    update();
    setInterval(update, 1000);
  }

  // ===== TESTIMONIALS SLIDER =====
  function initTestimonialsSlider() {
    const track = $('.testimonials-track');
    const dots = $$('.testimonials-dot');
    if (!track) return;
    const cards = $$('.testimonial-card', track);
    let current = 0;
    let autoTimer;
    function goTo(idx) {
      current = (idx + cards.length) % cards.length;
      const cardWidth = cards[0].offsetWidth + 24; // gap
      track.style.transform = `translateX(-${current * cardWidth}px)`;
      dots.forEach((d, i) => d.classList.toggle('active', i === current));
    }
    dots.forEach((dot, i) => on(dot, 'click', () => { goTo(i); resetAuto(); }));
    function resetAuto() { clearInterval(autoTimer); autoTimer = setInterval(() => goTo(current + 1), 5000); }
    resetAuto();
    // Touch/drag support
    let startX, isDragging = false;
    on(track, 'mousedown', (e) => { startX = e.clientX; isDragging = true; });
    on(track, 'mousemove', (e) => { if (isDragging) e.preventDefault(); });
    on(track, 'mouseup', (e) => {
      if (!isDragging) return;
      isDragging = false;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 50) { goTo(current + (dx < 0 ? 1 : -1)); resetAuto(); }
    });
    on(track, 'touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    on(track, 'touchend', (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) { goTo(current + (dx < 0 ? 1 : -1)); resetAuto(); }
    });
  }

  // ===== NEWSLETTER POPUP =====
  function initNewsletterPopup() {
    const overlay = $('#newsletter-popup');
    if (!overlay) return;
    const close = overlay.querySelector('.popup-close, .popup-skip');
    const shown = sessionStorage.getItem('hg_popup_shown');
    if (shown) return;
    setTimeout(() => {
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }, 4000);
    const closePopup = () => {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
      sessionStorage.setItem('hg_popup_shown', '1');
    };
    $$('.popup-close, .popup-skip', overlay).forEach((el) => on(el, 'click', closePopup));
    on(overlay, 'click', (e) => { if (e.target === overlay) closePopup(); });
    const form = overlay.querySelector('form');
    if (form) {
      on(form, 'submit', (e) => {
        e.preventDefault();
        const btn = form.querySelector('[type=submit]');
        if (btn) { btn.textContent = '✓ Unlocked! Check your email.'; btn.disabled = true; }
        setTimeout(closePopup, 2500);
      });
    }
  }

  // ===== CART CONSTANTS =====
var FREE_SHIP_THRESHOLD = 3500; // cents — $35.00
  var B3G1_EVERY = 3;             // every 3 items = 1 free

  // ===== CART DRAWER =====
  function initCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('site-overlay');
    if (!drawer) return;

    window.openCartDrawer = function () {
      drawer.classList.add('open');
      if (overlay) overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      fetchCart();
    };
    window.closeCartDrawer = function () {
      drawer.classList.remove('open');
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
    };

    var toggle = document.querySelector('[data-cart-toggle]');
    on(toggle, 'click', function () { window.openCartDrawer(); });
    var closeBtn = drawer.querySelector('.cart-drawer__close');
    on(closeBtn, 'click', function () { window.closeCartDrawer(); });
    on(overlay, 'click', function () { window.closeCartDrawer(); });
  }

  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        window.HGCart = cart;
        renderCartDrawer(cart);
        updateCartCount(cart.item_count);
        updateFreeShipBar(cart);
        updateB3G1Banner(cart);
      })
      .catch(function () {});
  }

  // ===== FREE SHIPPING BAR — updates every element with these IDs =====
  function updateFreeShipBar(cart) {
    var fill = document.getElementById('free-ship-fill');
    var msg  = document.getElementById('free-ship-msg');
    if (!fill || !cart) return;

    var price = cart.total_price || 0;
    var pct   = Math.min(100, Math.round((price / FREE_SHIP_THRESHOLD) * 100));
    fill.style.width = pct + '%';

    if (msg) {
      if (price >= FREE_SHIP_THRESHOLD) {
        msg.textContent = '✓ Free shipping unlocked!';
        msg.style.color = 'var(--accent-neon-lime)';
        fill.style.background = 'var(--accent-neon-lime)';
        fill.style.boxShadow = '0 0 8px var(--accent-neon-lime)';
      } else {
        var remaining = ((FREE_SHIP_THRESHOLD - price) / 100).toFixed(2);
        msg.textContent = '$' + remaining + ' away from free shipping';
        msg.style.color = 'var(--accent-neon-cyan)';
        fill.style.background = 'linear-gradient(90deg,var(--accent-neon-cyan),var(--accent-neon-magenta))';
        fill.style.boxShadow = '0 0 8px var(--accent-neon-cyan)';
      }
    }
  }

  // ===== BUY 3 GET 1 FREE BANNER =====
  function updateB3G1Banner(cart) {
    var banner = document.getElementById('cart-b3g1-banner');
    var text   = document.getElementById('cart-b3g1-text');
    if (!banner || !cart) return;

var totalQty   = cart.item_count || 0;
var cyclePos   = totalQty % 4;
var inProgress = cyclePos === 0 ? 0 : cyclePos;
var needed     = 4 - inProgress;
var freeItems  = cyclePos === 0 && totalQty > 0 ? 1 : 0;

    // Always show if cart has any items
    if (totalQty === 0) {
      banner.style.display = 'none';
      return;
    }
    banner.style.display = 'flex';

    if (freeItems >= 1) {
      banner.classList.add('cart-promo-banner--active');
    if (text) text.innerHTML = '🎉 Add another guard and get it <strong style="color:var(--accent-neon-lime);">FREE</strong> — automatically applied!';
    } else if (inProgress === 0) {
      banner.classList.remove('cart-promo-banner--active');
      if (text) text.innerHTML = 'Add <strong>3 items</strong> to unlock 1 FREE item!';
    } else {
      banner.classList.remove('cart-promo-banner--active');
      var dots = '';
      for (var i = 1; i <= B3G1_EVERY; i++) {
        dots += '<span class="b3g1-dot' + (i <= inProgress ? ' b3g1-dot--filled' : '') + '"></span>';
      }
      if (text) text.innerHTML = dots + ' Add <strong>' + needed + ' more</strong> to unlock 1 FREE — ' + inProgress + '/' + B3G1_EVERY + ' collected.';
    }
  }

  // ===== RENDER CART DRAWER BODY =====
  function renderCartDrawer(cart) {
    var body    = document.getElementById('cart-drawer-body');
    var subtotal = document.getElementById('cart-subtotal');
    var countEl  = document.getElementById('drawer-item-count');
    var footer   = document.getElementById('cart-drawer-footer');

    if (!body) return;

    // Update subtotal
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

    // Update header count badge
    if (countEl) {
      countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
    }

    // Show/hide footer
    if (footer) footer.style.display = cart.item_count > 0 ? 'block' : 'none';

    // Empty state
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="cart-drawer__empty">'
        + '<div class="cart-drawer__empty-icon">🛒</div>'
        + '<p class="cart-drawer__empty-text">Your vault is empty</p>'
        + '<a href="/collections/all" class="btn btn-neon-cyan btn-sm" style="margin-top:16px;">Shop Now</a>'
        + '</div>';
      return;
    }

    // Line items
    body.innerHTML = cart.items.map(function (item) {
      var imgSrc = item.image
        ? item.image.replace(/(\.\w+)$/, '_200x200$1')
        : 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-1_large.png';

      var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cart-item__variant">' + item.variant_title + '</div>'
        : '';

      var discountLine = (item.original_line_price !== item.final_line_price)
        ? '<div class="cart-item__savings">Saving ' + formatMoney(item.original_line_price - item.final_line_price) + '</div>'
        : '';

      return '<div class="cart-item" data-key="' + item.key + '">'
        + '<a href="' + item.url + '"><img class="cart-item__image" src="' + imgSrc + '" alt="' + item.product_title + '" loading="lazy" width="72" height="72"></a>'
        + '<div class="cart-item__details">'
        + '<a href="' + item.url + '" class="cart-item__title">' + item.product_title + '</a>'
        + variantLine
        + '<div class="cart-item__qty-row">'
        + '<button class="qty-btn" data-action="decrease" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Decrease">−</button>'
        + '<span class="qty-value">' + item.quantity + '</span>'
        + '<button class="qty-btn" data-action="increase" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Increase">+</button>'
        + '<button class="qty-btn cart-item__remove-btn" data-action="remove" data-key="' + item.key + '" aria-label="Remove">✕</button>'
        + '</div>'
        + discountLine
        + '</div>'
        + '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>'
        + '</div>';
    }).join('');

    // Bind qty buttons
    var qtyBtns = body.querySelectorAll('.qty-btn');
    qtyBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var action = btn.dataset.action;
        var key    = btn.dataset.key;
        var qty    = parseInt(btn.dataset.qty, 10);
        if (action === 'increase')  qty++;
        else if (action === 'decrease') qty = Math.max(0, qty - 1);
        else if (action === 'remove')   qty = 0;
        updateCartItem(key, qty);
      });
    });
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        window.HGCart = cart;
        renderCartDrawer(cart);
        updateCartCount(cart.item_count);
        updateFreeShipBar(cart);
        updateB3G1Banner(cart);
      })
      .catch(function () {});
  }

  function updateCartCount(count) {
    var els = document.querySelectorAll('.cart-count');
    els.forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  // ===== ADD TO CART =====
  function initAddToCart() {
    on(document, 'click', (e) => {
      const btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;
      const variantId = btn.dataset.variantId || btn.closest('[data-variant-id]')?.dataset.variantId;
      const qty = parseInt(btn.closest('[data-product-form]')?.querySelector('.qty-picker__input')?.value || 1);
      if (!variantId) return;
      e.preventDefault();
      btn.disabled = true;
      const originalText = btn.innerHTML;
      btn.innerHTML = '<span class="spinner"></span> Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty }),
      })
        .then(r => r.json())
        .then(() => {
          btn.innerHTML = '✓ Added!';
          btn.style.background = 'var(--accent-neon-cyan)';
          btn.style.color = 'var(--bg-dark)';
          fetchCart();
          setTimeout(() => {
            window.openCartDrawer && window.openCartDrawer();
            btn.innerHTML = originalText;
            btn.style.background = '';
            btn.style.color = '';
            btn.disabled = false;
          }, 800);
        })
        .catch(() => {
          btn.innerHTML = 'Error — Try Again';
          btn.disabled = false;
        });
    });
  }

  // ===== QUICK VIEW MODAL =====
  function initQuickView() {
    const modal = $('#quick-view-modal');
    if (!modal) return;
    window.openQuickView = function (handle) {
      fetch(`/products/${handle}.js`)
        .then(r => r.json())
        .then(product => renderQuickView(modal, product));
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    };
    on(modal, 'click', (e) => {
      if (e.target === modal || e.target.closest('.quick-view-close')) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
    on(document, 'click', (e) => {
      const btn = e.target.closest('[data-quick-view]');
      if (btn) {
        e.preventDefault();
        window.openQuickView(btn.dataset.quickView);
      }
    });
  }

  function renderQuickView(modal, product) {
    const variant = product.variants[0];
    const img = product.images[0] || '';
    const box = modal.querySelector('.quick-view-box');
    if (!box) return;
    box.innerHTML = `
      <div class="quick-view-images">
        <img class="quick-view-main-img" src="${img}" alt="${product.title}" loading="lazy">
      </div>
      <div class="quick-view-body">
        <button class="quick-view-close" aria-label="Close">✕</button>
        <div class="product-info__collection">${product.type || 'HardGuard™'}</div>
        <h2 class="product-info__title">${product.title}</h2>
        <div class="product-info__price-row">
          <span class="product-info__price">${formatMoney(variant.price)}</span>
          ${variant.compare_at_price && variant.compare_at_price > variant.price
            ? `<span class="product-info__compare-price">${formatMoney(variant.compare_at_price)}</span>` : ''}
        </div>
        <p class="product-info__description">${product.description?.slice(0, 200)}${product.description?.length > 200 ? '...' : ''}</p>
        <button class="atc-btn" data-add-to-cart data-variant-id="${variant.id}" style="width:100%;margin-bottom:12px;">
          Add to Cart
        </button>
        <a href="/products/${product.handle}" class="btn btn-dark" style="width:100%;display:flex;align-items:center;justify-content:center;">
          View Full Details →
        </a>
      </div>
    `;
  }

  // ===== SEARCH MODAL =====
  function initSearch() {
    const modal = $('#search-modal');
    const input = modal?.querySelector('.search-input');
    if (!modal) return;
    on($('[data-search-toggle]'), 'click', () => {
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
      setTimeout(() => input?.focus(), 100);
    });
    const close = () => {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    };
    on(modal.querySelector('.search-close'), 'click', close);
    on(modal, 'click', (e) => { if (e.target === modal) close(); });
    on(document, 'keydown', (e) => { if (e.key === 'Escape') { close(); } });
  }

  // ===== PRODUCT GALLERY =====
  function initProductGallery() {
    // Product page gallery is handled by inline script in product.liquid.
    // Skip if product page inline script already ran (window.__variantData exists).
    if (window.__variantData) return;
    const main = $('.product-gallery__main');
    const thumbs = $$('.product-gallery__thumb');
    if (!main || !thumbs.length) return;
    const mainImg = main.querySelector('img');
    thumbs.forEach(thumb => {
      on(thumb, 'click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        if (mainImg) mainImg.src = thumb.dataset.src || thumb.querySelector('img')?.src;
      });
    });
  }

  // ===== VARIANT SELECTOR =====
  // Handled by inline script in product.liquid which has access to Liquid data.
  // This global init is a no-op to avoid double-binding.
  function initVariantSelector() {}

  // ===== QTY PICKER =====
  function initQtyPicker() {
    $$('.qty-picker__btn').forEach(btn => {
      on(btn, 'click', () => {
        const input = btn.closest('.qty-picker')?.querySelector('.qty-picker__input');
        if (!input) return;
        let v = parseInt(input.value) || 1;
        if (btn.dataset.action === 'plus') v++;
        if (btn.dataset.action === 'minus') v = Math.max(1, v - 1);
        input.value = v;
      });
    });
  }

  // ===== ACCORDION =====
  function initAccordions() {
    $$('.accordion-btn').forEach(btn => {
      on(btn, 'click', () => {
        const item = btn.closest('.accordion-item');
        const isOpen = item.classList.contains('open');
        $$('.accordion-item.open', item.closest('.accordion')).forEach(i => i.classList.remove('open'));
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  // ===== STICKY ATC =====
  // Handled by inline script in product.liquid.
  // This global init is a no-op to avoid double IntersectionObserver.
  function initStickyATC() {}

  // ===== LAZY IMAGES =====
  function initLazyImages() {
    if ('IntersectionObserver' in window) {
      const imgs = $$('img[loading="lazy"]');
      // Browser handles lazy loading natively — no-op
    }
  }

  // ===== SCROLL ANIMATIONS =====
  function initScrollAnimations() {
    const elements = $$('[data-animate]');
    if (!elements.length) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-up');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    elements.forEach(el => observer.observe(el));
  }

  // ===== NEON CURSOR TRAIL (desktop) =====
  function initCursorTrail() {
    if (window.innerWidth < 1024) return;
    const trail = document.createElement('div');
    trail.style.cssText = `
      position:fixed;width:8px;height:8px;border-radius:50%;
      background:var(--accent-neon-cyan);pointer-events:none;z-index:99999;
      box-shadow:0 0 10px var(--accent-neon-cyan),0 0 20px var(--accent-neon-cyan);
      transition:transform 0.1s ease;transform:translate(-50%,-50%);
      opacity:0;
    `;
    document.body.appendChild(trail);
    let mx = 0, my = 0, tx = 0, ty = 0;
    on(document, 'mousemove', (e) => {
      mx = e.clientX; my = e.clientY;
      trail.style.opacity = '0.6';
    });
    on(document, 'mouseleave', () => { trail.style.opacity = '0'; });
    function animate() {
      tx += (mx - tx) * 0.2;
      ty += (my - ty) * 0.2;
      trail.style.left = tx + 'px';
      trail.style.top = ty + 'px';
      requestAnimationFrame(animate);
    }
    animate();
  }

  // ===== PRODUCT CARD QUICK-ADD =====
  function initQuickAdd() {
    on(document, 'click', (e) => {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.dataset.quickAdd;
      if (!variantId) return;
      btn.innerHTML = '...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      }).then(() => {
        btn.innerHTML = '✓';
        btn.style.background = 'var(--accent-neon-cyan)';
        btn.style.color = 'var(--bg-dark)';
        fetchCart();
        setTimeout(() => {
          btn.innerHTML = '+';
          btn.style.background = '';
          btn.style.color = '';
        }, 1500);
      }).catch(() => { btn.innerHTML = '+'; });
    });
  }

  // ===== INIT =====
  document.addEventListener('DOMContentLoaded', () => {
    initHeaderScroll();
    initMobileNav();
    initAnnouncementBar();
    initCountdown();
    initTestimonialsSlider();
    initNewsletterPopup();
    initCartDrawer();
    initAddToCart();
    initQuickView();
    initSearch();
    initProductGallery();
    initVariantSelector();
    initQtyPicker();
    initAccordions();
    initStickyATC();
    initLazyImages();
    initScrollAnimations();
    initCursorTrail();
    initQuickAdd();
    fetchCart();
  });

})();


// ===== HardGuard Full Conversion Upgrade JS =====
document.addEventListener('DOMContentLoaded', function(){
  function setQty(qty){
    document.querySelectorAll('#product-qty,.qty-picker__input').forEach(function(input){ input.value = qty; });
  }
  document.querySelectorAll('[data-bundle-qty]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var qty=parseInt(btn.getAttribute('data-bundle-qty'),10)||1;
      setQty(qty);
      document.querySelectorAll('[data-bundle-qty]').forEach(function(b){b.classList.remove('active')});
      btn.classList.add('active');
      var msg=document.getElementById('hg-bundle-message');
      var fill=document.getElementById('hg-bundle-fill');
      if(msg){ msg.textContent = qty >= 4 ? '4 selected — free guard unlocked.' : ('Add ' + (4-qty) + ' more to unlock your free guard.'); }
      if(fill){ fill.style.width = Math.min(100, Math.round((qty/4)*100)) + '%'; }
    });
  });
  var viewer=document.getElementById('hg-live-viewers');
  var sold=document.getElementById('hg-live-sold');
  if(viewer){ viewer.textContent = String(9 + Math.floor(Math.random()*12)); }
  if(sold){ sold.textContent = String(2 + Math.floor(Math.random()*5)); }
});
